<template>
  <div v-if="showContractModal" class="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50">
    <div class="bg-white rounded-lg shadow-xl max-w-4xl w-full mx-4 max-h-[90vh] flex flex-col">
      <div class="p-6 border-b">
        <h2 class="text-2xl font-bold text-gray-800">Contrato de Atendimento</h2>
        <div v-if="contractUpdated" class="mt-3 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
          <div class="flex items-start gap-3">
            <svg class="w-6 h-6 text-yellow-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
            <div>
              <p class="text-yellow-800 font-semibold">Atenção: Contrato Atualizado</p>
              <p class="text-yellow-700 text-sm mt-1">O contrato foi atualizado. Por favor, leia atentamente as novas cláusulas e aceite para continuar.</p>
            </div>
          </div>
        </div>
        <p v-else-if="!patientContract?.accepted" class="text-sm text-gray-600 mt-2">Por favor, leia e aceite o contrato</p>
      </div>
      
      <div class="p-6 overflow-y-auto flex-1">
        <div v-html="patientContract?.content" class="ck-content text-black"></div>
      </div>
      
      <div class="p-6 border-t flex justify-end gap-4">
        <template v-if="!patientContract?.accepted || contractUpdated">
          <button 
            @click="acceptContract" 
            class="px-6 py-3 bg-secondary text-white rounded-lg hover:bg-secondary-700 transition font-semibold"
          >
            Aceitar
          </button>
        </template>
        <template v-else>
        <button 
          @click="showContractModal = false" 
          class="px-6 py-3 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition font-semibold"
        >
          Fechar
        </button>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, watch } from 'vue'
import { useContract } from '~/composables/useContract'
import { useUserStore } from '~/stores/user'

const { showContractModal, patientContract, contractUpdated, acceptContract, checkContract } = useContract()
const userStore = useUserStore()

onMounted(() => {
  if (userStore.isLogged) {
    checkContract()
  }
})

watch(() => userStore.isLogged, (isLogged) => {
  if (isLogged) {
    checkContract()
  }
})
</script>

<style scoped>
.ck-content {
  line-height: 1.6;
}

.ck-content p {
  margin-bottom: 1em;
}

.ck-content ul {
  list-style-type: disc;
  margin-left: 1.5em;
  margin-bottom: 1em;
}

.ck-content ol {
  list-style-type: decimal;
  margin-left: 1.5em;
  margin-bottom: 1em;
}

.ck-content ul ul {
  list-style-type: circle;
}

.ck-content li {
  margin-bottom: 0.5em;
  display: list-item;
}

.ck-content h1,
.ck-content h2,
.ck-content h3 {
  font-weight: bold;
  margin-top: 1em;
  margin-bottom: 0.5em;
}

.ck-content strong {
  font-weight: bold;
}

.ck-content em {
  font-style: italic;
}
</style>
